import * as React from 'react';

import { cn } from '../../utils';

function Skeleton({ className, ...props }: React.HTMLAttributes<HTMLDivElement>) {
  return <div className={cn('animate-pulse rounded-md bg-surface/10', className)} {...props} />;
}

export { Skeleton };
